import axios from 'axios';
import router from '@/router/index.js';

// Add a response interceptor
axios.interceptors.response.use(undefined,
	function (error) {
		if (error.message === 'Request failed with status code 503') {
			router.replace({ name: 'maintenance'});
		}
		return Promise.reject(error);
	}
);

export default axios;